var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_1059_4499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.499 0H19.998C19.722 0 19.497 0.225 19.497 0.501C19.497 1.05 19.047 1.5 18.498 1.5C17.949 1.5 17.499 1.05 17.499 0.501C17.499 0.225 17.274 0 16.998 0H0.501C0.225 0 0 0.225 0 0.501V14.502C0 14.778 0.225 15.003 0.501 15.003H17.001C17.277 15.003 17.502 14.778 17.502 14.502C17.502 13.953 17.952 13.503 18.501 13.503C19.05 13.503 19.5 13.953 19.5 14.502C19.5 14.778 19.725 15.003 20.001 15.003H23.499C23.775 15.003 24 14.778 24 14.502V0.501C24 0.225 23.775 0 23.499 0ZM23.001 14.001H20.43C20.205 13.14 19.431 12.501 18.501 12.501C17.571 12.501 16.797 13.14 16.572 14.001H0.999V0.999H16.569C16.788 1.839 17.532 2.463 18.438 2.493C18.192 2.523 18 2.724 18 2.979V3.609C18 3.885 18.225 4.11 18.501 4.11C18.777 4.11 19.002 3.885 19.002 3.609V2.979C19.002 2.724 18.807 2.517 18.564 2.49C19.47 2.466 20.214 1.836 20.433 0.996H23.001V14.001Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.501 4.99414C18.225 4.99414 18 5.21914 18 5.49514V6.12514C18 6.40114 18.225 6.62614 18.501 6.62614C18.777 6.62614 19.002 6.40114 19.002 6.12514V5.49514C19.002 5.21914 18.777 4.99414 18.501 4.99414Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.501 7.62891C18.225 7.62891 18 7.85391 18 8.12991V8.75991C18 9.03591 18.225 9.26091 18.501 9.26091C18.777 9.26091 19.002 9.03591 19.002 8.75991V8.12991C19.002 7.85391 18.777 7.62891 18.501 7.62891Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.501 10.2656C18.225 10.2656 18 10.4906 18 10.7666V11.3966C18 11.6726 18.225 11.8976 18.501 11.8976C18.777 11.8976 19.002 11.6726 19.002 11.3966V10.7666C19.002 10.4876 18.777 10.2656 18.501 10.2656Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.99899 4.25005H8.49899C8.77499 4.25005 8.99999 4.02505 8.99999 3.74905C8.99999 3.47305 8.77499 3.24805 8.49899 3.24805H3.99899C3.72299 3.24805 3.49799 3.47305 3.49799 3.74905C3.49799 4.02505 3.72299 4.25005 3.99899 4.25005Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12 5.75195H3.99899C3.72299 5.75195 3.49799 5.97695 3.49799 6.25295C3.49799 6.52895 3.72299 6.75395 3.99899 6.75395H12C12.276 6.75395 12.501 6.52895 12.501 6.25295C12.501 5.97695 12.276 5.75195 12 5.75195Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12 8.25H3.99899C3.72299 8.25 3.49799 8.475 3.49799 8.751C3.49799 9.027 3.72299 9.252 3.99899 9.252H12C12.276 9.252 12.501 9.027 12.501 8.751C12.501 8.475 12.276 8.25 12 8.25Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12 10.748H3.99899C3.72299 10.748 3.49799 10.973 3.49799 11.249C3.49799 11.525 3.72299 11.75 3.99899 11.75H12C12.276 11.75 12.501 11.525 12.501 11.249C12.501 10.973 12.276 10.748 12 10.748Z",
    fill: "#757B81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1059_4499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.07389fd7c7c54a3c0e1720d3d8ede58d.svg";
export { ForwardRef as ReactComponent };